<template>
  <section class="mt-5 mb-5">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 text-right">
          <button class="btn btn-light" @click.prevent="signOutPartner"><i class="fas fa-power-off"></i> ออกจากระบบ</button>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12">
          <div class="card">
            <h5 class="card-header">
              <span>รายงานการให้บริการ Grab</span>
              <img v-if="partner" :src="partner.picture" class="img-fluid float-right" alt="" width="100">
            </h5>
            <div class="card-body">
              <form @submit.prevent="searchOrderWithStat">
                <div class="row">
                  <div class="col-4">
                    <div class="form-group">
                      <label for="">กำหนดช่วงเวลา</label>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" v-model="searchParams.type_date" required
                               name="type_date" id="type_date1" value="order_date">
                        <label class="form-check-label" for="type_date1">
                          วันที่ทำการจอง
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" v-model="searchParams.type_date"
                               name="type_date" id="type_date2" value="cleaning_date">
                        <label class="form-check-label" for="type_date2">
                          วันที่ใช้บริการ
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-8">
                    <div class="row">
                      <div class="col-6">
                        <div class="form-group">
                          <label for="startDate">วันที่เริ่มต้น</label>
                          <input type="text" id="startDate" name="startDate"
                                 v-validate="'required'"
                                 readonly placeholder="วันที่เริ่มต้น" data-vv-as="วันที่เริ่มต้น"
                                 @change="updateDate('start_date', $event)"
                                 :class="{'form-control':true, '-date-picker': true,'is-invalid': errors.has('startDate') }">
                          <span v-show="errors.has('startDate')" class="help text-danger">{{ errors.first('startDate') }}</span>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group">
                          <label for="endDate">วันที่สิ้นสุด</label>
                          <input type="text" id="endDate" name="endDate"
                                 v-validate="'required'" data-vv-as="วันที่สิ้นสุด"
                                 readonly placeholder="วันที่สิ้นสุด"
                                 @change="updateDate('end_date', $event)"
                                 :class="{'form-control':true, '-date-picker': true,'is-invalid': errors.has('endDate') }">
                          <span v-show="errors.has('endDate')" class="help text-danger">{{ errors.first('endDate') }}</span>

                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <button class="btn btn-success" type="submit">ค้นหา</button>
                    <button class="btn btn-light ml-3" type="button" @click="clearValue">ล้างค่า</button>
                  </div>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-12">
          <div class="card">
            <h5 class="card-header">สถิติทั่วไป</h5>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table">
                  <tbody>
                  <tr>
                    <td>จำนวนการจองทั้งหมด (Total Bookings):</td>
                    <td>{{ partnerGrabData ? partnerGrabData.total_bookings : '' }}</td>
                  </tr>
                  <tr>
                    <td>จำนวนการจองที่มีคุณแม่บ้านรับงาน (Allocated Bookings):</td>
                    <td>{{ partnerGrabData ? partnerGrabData.allocated_bookings : '' }}</td>
                  </tr>
                  <tr>
                    <td>จำนวนงานที่ให้บริการแล้วเสร็จ (Completed Bookings):</td>
                    <td>{{ partnerGrabData ? partnerGrabData.completed_bookings : '' }}</td>
                  </tr>
                  <!--                <tr>
                    <td>เฉลี่ยคะแนน Review (Avg Ratings):</td>
                    <td>sss</td>
                  </tr>-->
                  <tr>
                    <td>จำนวนเคสที่มีปัญหาการให้บริการ (Reported Case):</td>
                    <td>{{ partnerGrabData ? partnerGrabData.reported_case : '' }}</td>
                  </tr>
                  <tr>
                    <td>เฉลี่ยระยะเวลารอคุณแม่บ้านรับงาน (AVG lead time for booking allocation):</td>
                    <td>{{ partnerGrabData ? partnerGrabData.avg_time_allocation_orders + ' นาที' : '' }}</td>
                  </tr>
                  <tr>
                    <td>จำนวนงานที่ไม่มีคุณแม่บ้านรับงาน (Unallocated bookings):</td>
                    <td>{{ partnerGrabData ? partnerGrabData.unallocated_bookings : '' }}</td>
                  </tr>
                  <tr>
                    <td>จำนวนเคสที่มีการถูกยกเลิก (PAX cancelled bookings):</td>
                    <td>{{ partnerGrabData ? partnerGrabData.cancel_bookings : '' }}</td>
                  </tr>
                  <tr>
                    <td>% AR งานที่มีคุณแม่บ้านรับงาน (AR = allocated bookings / total bookings):</td>
                    <td>{{ partnerGrabData ? partnerGrabData.percentage_allocatated_booking + '%' : '' }}</td>
                  </tr>
                  <tr>
                    <td>% FR งานเสร็จสิ้น (FR = completed bookings / total bookings):</td>
                    <td>{{ partnerGrabData ? partnerGrabData.percentage_completed_booking + '%' : '' }}</td>
                  </tr>
                  </tbody>

                </table>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <form @submit.prevent="searchOrder">
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label for="">เงื่อนไขการค้นหาอื่น:</label>
                      <input type="text" class="form-control" v-model="searchParams.keyword" required
                             placeholder="Booking ID/ Reference ID/ เบอร์โทร/ Email คุณลูกค้า">
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label for="" class="mr-3">เรียงข้อมูล:</label>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="order_by" id="order_by1" value="asc" v-model="searchParams.order_by">
                        <label class="form-check-label" for="order_by1">น้อยไปมาก</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="order_by" id="order_by2" value="desc" v-model="searchParams.order_by">
                        <label class="form-check-label" for="order_by2">มากไปน้อย</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <button class="btn btn-success" type="submit">ค้นหา</button>
                    <button class="btn btn-light ml-3" type="button"
                            @click="searchAndClearValue">รีเซ็ท
                    </button>
                  </div>
                </div>
              </form>


            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 text-right">
          <template v-if="!partnerGrabData || !partnerGrabData.bookings || partnerGrabData.bookings.length < 0">
            <button class="btn btn-success btn-sm" disabled>EXPORT</button>
          </template>
          <template v-else>
            <a class="btn btn-success btn-sm" :href="exportReport" target="_blank">EXPORT</a>
          </template>

        </div>
      </div>

      <div class="row mt-3" v-if="partnerGrabData && partnerGrabData.bookings && partnerGrabData.bookings.length > 0">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table">
              <thead>
              <tr>
                <th class="text-center">#</th>
                <th class="text-center">Booking ID</th>
                <th class="text-center">Reference ID</th>
                <th class="text-center" style="width: 15%;">วันที่ทำรายการ</th>
                <th class="text-center">ชื่อคุณลูกค้า</th>
                <th class="text-center">ชื่อสถานที่</th>
                <th class="text-center">ระยะเวลาที่คุณแม่บ้านรับงาน (ชม.)</th>
                <th class="text-center">สถานะการให้บริการ</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in partnerGrabData.bookings" :key="index">
                <td class="text-center">{{ index + 1 }}</td>
                <td class="text-center">{{ item.order_code }}</td>
                <td class="text-center">{{ item.partner_order_commission ? item.partner_order_commission.reference : '' }}</td>
                <td class="text-center">{{ item.order_date | prettyDate }}</td>
                <td class="text-center">{{ item.name }}</td>
                <td class="text-center">{{ item.address }}</td>
                <td class="text-center">{{ diffDurationTime(item.order_date, item.confirm_cleaning_date, true) }}</td>
                <td class="text-center">
                  <template v-if="item.cancel > 0">
                    <span class="text-danger">งานถูกยกเลิิก</span>
                  </template>
                  <template v-else>
                  <span v-if="item.status === 0" class="text-warning">
                  ยังไม่มีคุณแม่บ้านรับงาน
                </span>
                    <span v-else-if="item.status === 1" class="text-info">
                  มีคุณแม่บ้านรับงานแล้ว
                </span>
                    <span v-else-if="item.status === 2" class="text-success">
                  ให้บริการเสร็จแล้ว
                </span>
                  </template>
                </td>
              </tr>

              <tr>
                <td colspan="6"></td>
                <td class="text-center" style="border-top: 1px solid black;">เฉลี่ย = {{ convertAvgHour }} ชม.</td>
                <td class="text-center"></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
import Pickaday from 'pikaday'
// import 'pikaday/css/pikaday.css'
import moment from 'moment'
import axios from 'axios'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'BookingGrabReport',
  data () {
    return {
      searchParams: {
        type_date: 'order_date',
        start_date: '',
        end_date: '',
        keyword: '',
        order_by: 'asc'
      },
      pickerEndDate: null,
      pickerStartDate: null,
      partnerGrabData: null
    }
  },
  computed: {
    ...mapState({
      token: state => state.authPartner.token,
      partner: state => state.authPartner.partner
    }),

    exportReport () {
      const typeDate = this.searchParams.type_date
      const startDate = this.searchParams.start_date
      const endDate = this.searchParams.end_date
      return axios.defaults.baseURL + `/partners/orders/grab/reports?type_date=${typeDate}&start_date=${startDate}&end_date=${endDate}&export=1&token=${this.token}`
    },

    convertAvgHour () {
      let resultHour = 0
      if (this.partnerGrabData && this.partnerGrabData.bookings && this.partnerGrabData.bookings.length > 0) {
        this.partnerGrabData.bookings.forEach(item => {
          resultHour += Number(this.diffDurationTime(item.order_date, item.confirm_cleaning_date, false))
        })
      }

      if (resultHour > 0) {
        resultHour = resultHour / this.partnerGrabData.bookings.length
      }

      return resultHour
    }
  },
  methods: {
    ...mapActions('authPartner', {
      LOGOUT: 'LOGOUT'
    }),
    signOutPartner () {
      this.LOGOUT()
      this.$router.push({path: '/partners/login', replace: true})
    },
    searchAndClearValue () {
      this.searchParams.keyword = ''
      this.searchParams.order_by = 'asc'
      this.searchOrderWithStat()
    },
    diffDurationTime (orderDate, confirmCleaningDate, withString = false) {
      if (!orderDate || !confirmCleaningDate) return ''

      orderDate = moment(orderDate)

      confirmCleaningDate = moment(confirmCleaningDate)
      let result = 0

      const hour = confirmCleaningDate.diff(orderDate, 'hours')
      orderDate.add(hour, 'hours')
      if (hour && hour > 0) {
        result += hour
        if (withString) result += ' ชม. '
      }

      if (withString) {
        const minute = confirmCleaningDate.diff(orderDate, 'minutes')
        orderDate.add(minute, 'minutes')
        if (minute && minute > 0) {
          result += minute + ' นาที'
        }
      }

      return result
    },
    clearValue () {
      document.getElementById('endDate').value = ''
      document.getElementById('startDate').value = ''
      this.searchParams.start_date = ''
      this.searchParams.end_date = ''
      this.$validator.reset()
    },
    searchOrderWithStat () {
      const headers = { 'Authorization': `Bearer ${this.token}` }
      try {
        this.$validator.validate().then(async (valid) => {
          if (valid) {
            let url = 'partners/orders/grab/reports'
            const { data } = await axios.get(url, {
              headers,
              params: {
                type_date: this.searchParams.type_date,
                start_date: this.searchParams.start_date,
                end_date: this.searchParams.end_date
              }
            })
            this.partnerGrabData = JSON.parse(JSON.stringify(data.data))
          }
        })
      } catch (err) {
        this.$swal({ text: 'ผิดพลาด [CODE: API ERROR] กรุณาติดต่อผู้ดูแลระบบ', type: 'error' })
      }
    },
    async searchOrder () {
      const headers = { 'Authorization': `Bearer ${this.token}` }
      let url = 'partners/orders/grab/bookings'
      const { data } = await axios.get(url, {
        headers,
        params: {
          keyword: this.searchParams.keyword,
          order_by: this.searchParams.order_by
        }
      })
      this.partnerGrabData.bookings = JSON.parse(JSON.stringify(data.bookings))
    },
    updateDate (attribute, e) {
      const date = moment(e.target.value, 'DD/MM/yyyy').format('yyyy-MM-DD')
      this.searchParams[attribute] = date

      if (attribute === 'start_date') {
        const endDate = document.getElementById('endDate')
        endDate.value = ''
        this.searchParams.end_date = ''
        this.pickerEndDate.setMinDate(moment(date).toDate())
      }
      this.$forceUpdate()
      this.getOrderReport()
    },
    initEndDate () {
      const datepicker = document.getElementById('endDate')
      this.pickerEndDate = new Pickaday({
        field: datepicker,
        format: 'DD/MM/YYYY',
        minDate: moment(this.searchParams.start_date).toDate(),
        onSelect: () => {
          const newDate = new Date(this.pickerEndDate._d)
          datepicker.value = moment(newDate).format('DD/MM/YYYY')
          this.searchParams.end_date = moment(newDate).format('YYYY-MM-DD')
        }
      })
    },
    initStartDate () {
      const datepicker = document.getElementById('startDate')
      this.pickerStartDate = new Pickaday({
        field: datepicker,
        format: 'DD/MM/YYYY',
        onSelect: () => {
          const newDate = new Date(this.pickerStartDate._d)
          datepicker.value = moment(newDate).format('DD/MM/YYYY')
          this.searchParams.start_date = moment(newDate).format('YYYY-MM-DD')
        }
      })
    }
  },
  mounted () {
    this.initEndDate()
    this.initStartDate()
  }
}
</script>

<style scoped>
@import '~pikaday/css/pikaday.css';
</style>



// WEBPACK FOOTER //
// src/components/partner/BookingGrabReport.vue